<template>
  <div class="login" :class="{ w420: isPage }">
    <div class="form">
      <ul class="form_ul">
        <li class="form_li">
          <div class="form_in">
            <div class="input">
              <input type="text" placeholder="아이디" v-model="form.userId" v-on:keyup.enter="fnSignIn">
              <p class="valid" :class="{ on: $v.form.userId.$error }">{{ msg.userId }}</p><!--'on 추가'-->
            </div>
          </div>
        </li>
        <li class="form_li">
          <div class="form_in">
            <div class="input">
              <input type="password" placeholder="비밀번호" v-model="form.userPw" v-on:keyup.enter="fnSignIn">
              <p class="valid" :class="{ on: $v.form.userPw.$error }">{{ msg.userPw }}</p><!--'on 추가'-->
            </div>
          </div>
        </li>
      </ul>
    </div>
    <button class="btn" @click="fnSignIn">로그인</button>
    <div class="btn_wrap">
      <button @click="fnPage(1)">아이디 찾기</button>
      <button @click="fnPage(2)">비밀번호 찾기</button>
      <button @click="fnPage(3)">회원가입</button>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'sign-in-index',
  props: {
    isPage: {
      type: [Boolean],
      default: false
    }
  },
  computed: {
    userData() {
      return this.$store.getters['user/getUserData']
    }
  },
  data: function() {
    return {
      form: {
        userId: '',
        userPw: '',
        applicationId: 'site'
      },
      msg: {
        userId: '',
        userPw: ''
      },
      isNotMatchUserPw: true,
      isNotMatchUserId: true,
    }
  },
  methods: {
    fnPage: function(type) {
      if (type === 1) {
        this.$router.push({ path: '/sign/find/id' })
      } else if(type === 2 ){
        this.$router.push({ path: '/sign/find/password/step1' })
      }
      else {
        this.$router.push({ path: '/sign/up/step1' })
      }
    },
    fnSignIn: async function() {
      this.isNotMatchUserPw = true
      this.isNotMatchUserId = true
      this.$v.$touch()
      if (!this.$Util.isValid(this.$v, this.$el)) {
        return false
      }
      const resDuplicate = await this.$SignSvc.userDuplicateValidCheck(this.form)
        if(resDuplicate.code === -1013) {// 동시 로그인 방지 기능 생성 (서남아이에스 임현아, 2024-09-09)
          console.log('여기임')
          const message = '이미 연결되어있는 홈페이지가 있습니다.<br/>연결을 해제하고 로그인 하시겠습니까?'
          const type = 'checkLoginSession'
          const itemList = {userId : this.form.userId, userPw : this.form.userPw}

          this.$store.commit('layout/setModalAlert', { data: { message, type, itemList }, modalAlertName: this.$modalAlertNames.MODAL_COMMON_CONFIRM_INFO })
          
          return false
        } else {
          const res = await this.$SignSvc.login(this.form)
      if (res.code === 1) {
        if (res.entity.isAuth === 2 || res.entity.isAuth < 0 || res.entity.isAuth === null) {
          alert('본인인증을 진행해주시길 바랍니다.')
          await this.$router.replace({
            path: '/sign/up/step1'
          })
          return false
        }
        await this.$router.replace({ path: '/main' })
      } else {
        if (res.code === -1002) {
          this.isNotMatchUserPw = false
          this.msg.userPw = res.message
          return false
        } else if (res.code === -1000) {
          this.isNotMatchUserId = false
          this.msg.userId = res.message
          return false
        } else if (res.code === -1005) {          
          this.isNotMatchUserId = false
          this.msg.userId = res.message

          // 홈페이지 유지보수 개발요청안 | 비회원 대상 Alert 추가 (서남아이에스 임현아, 2024-07-02)      
          const message = '휴면 회원입니다. 휴면 회원 해제를 진행하시겠습니까?'
          const type = 'changeUserStatus'

          this.$store.commit('layout/setModalAlert', { data: { message, type }, modalAlertName: this.$modalAlertNames.MODAL_COMMON_CONFIRM_INFO })

          return false
        } else {
          this.isNotMatchUserId = false
          this.msg.userId = res.message
          return false
        }
      }}
    }
  },
  validations: {
    form: {
      userId: {
        test: function(val) {
          if (!this.isNotMatchUserId) {
            return false
          }
          if (!required(val)) {
            this.msg.userId = '아이디를 입력해주세요.'
            return false
          }
          if (val.length < 5) {
            this.msg.userId = '올바르지 않은 아이디 형식입니다.'
            return false
          }
          return true
        }
      },
      userPw: {
        test: function(val) {
          if (!this.isNotMatchUserPw) {
            return false
          }
          if (!required(val)) {
            this.msg.userPw = '비밀번호를 입력해주세요.'
            return false
          }
          if (val.length < 4) {
            this.msg.userPw = '숫자 4자 이상 입력해주세요.'
            return false
          }
          return true
        }
      }
    }
  }
}
</script>

<style scoped></style>
